module.exports = __webpack_public_path__ + "media/images/lp_reason-6-3b508d551fd47967aed19c1db64b2d96.webp";